import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { userIsAuthSC } from '@entities/user/model/user.selectors';
import { ADMIN_LOGIN_URL } from '@app/routes';

const ProtectedRouteComponent = ({children}) => {
  const isUserAuth = useSelector(userIsAuthSC);

  if (!isUserAuth) {
    localStorage.setItem('fullpath', window.location.pathname + window.location.search);
  }

  return isUserAuth ? children : (<Navigate to={ ADMIN_LOGIN_URL.pathname } replace />);
};

export default ProtectedRouteComponent;
